import { render } from "./pagesinstructor-sidebar.vue?vue&type=template&id=22b7aae4"
import script from "./pagesinstructor-sidebar.vue?vue&type=script&lang=js"
export * from "./pagesinstructor-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__